import classNames from 'classnames';
import type { ScrolledContentState } from '../hooks/useScrolledContentState';
import type { SidePanelSize } from './SidePanel.types';

type SidePanelClassNames = {
  root: string;
  header: string;
  content: string;
  footer: string;
};

export const getSidePanelClassNames = (
  size: SidePanelSize,
  scrolledContentState: ScrolledContentState,
  className?: string,
  title?: string,
  hasBackButton = false,
): SidePanelClassNames => {
  const isHeaderShadowVisible =
    scrolledContentState === 'bottom' || scrolledContentState === 'middle';

  const isFooterShadowVisible =
    scrolledContentState === 'top' || scrolledContentState === 'middle';

  return {
    root: classNames(
      'h-screen flex flex-col bg-colored-light overflow-hidden', // overflow-hidden added to contain footer/header shadows
      size === 'large' ? 'w-[660px]' : ' w-[448px]',
      className,
    ),
    header: classNames(
      'flex flex-row items-center p will-change-transform', // will-change-transform fixes incorrect rendering of shadow in Safari
      title ? 'justify-between' : 'justify-end',
      hasBackButton && 'gap-2xs',
      'border-b border-b-default bg-default',
      isHeaderShadowVisible && 'shadow-lg',
    ),
    content: classNames('p grow overflow-auto'),
    footer: classNames(
      'p border-t border-t-default bg-default will-change-transform', // will-change-transform fixes incorrect rendering of shadow in Safari
      isFooterShadowVisible && 'shadow-lg-reversed',
    ),
  };
};
